<template>
  <div class="row">
    <div class="col-lg-2 mb-3">
      <div class="tab-title-divider d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <span class='tab-title'>Services</span>
        <router-link class="float-right tab-add form-action-text text-secondary white-space-nowrap"
          :to="{ name: 'newService', params: {
          project_id: $route.params.project_id}}"
        >
          + Add
        </router-link>
      </div>
      <LoadingSpinner v-if="servicesLoading" message="Loading Services" size="1x" />
      <!-- eslint-disable-next-line max-len -->
      <router-link class="btn btn-block btn-secondary btn-sm text-white mb-3 d-md-none d-lg-none d-xl-none d-block d-sm-block white-space-nowrap"
                   :to="{ name: 'newService', params: {
                   project_id: $route.params.project_id}}"
                   tag="button">
        + Add
      </router-link>
      <template v-if="!servicesLoading">
        <h6 v-if="orderedServices && !orderedServices.length">No Services Found</h6>
        <ul class="nav nav-pills flex-column mb-3">
          <li v-for='service in orderedServices'
            :key='service.id'
            class="nav-item">
            <router-link
              class="nav-link text-left py-1 px-2"
              :to="{ name: 'projectService', params: {
                      project_id: $route.params.project_id,
                      id: service.id }}">
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-between">
                  <div>
                    {{ service.id }}
                    <template v-if="service.openDate">
                      ({{ service.openDate | yearFromDateTimeString }})
                    </template>
                    <small v-if="service.isMultiProperty" class="important-tag">
                      MP
                    </small>
                  </div>
                  <font-awesome-icon
                    :id="'service-' + service.id"
                    icon="circle"
                    class="rounded-circle border border-white border-circle"
                    size="sm"
                    :aria-label="`Status: ${service.statusId}`"
                    :class="getStatusClass(service.statusId, 'Service')"
                  />
                  <b-tooltip :target="'service-' + service.id">
                    {{getStatusName(service.statusId)}}
                  </b-tooltip>
                </div>
                <small :id="'serviceCat-'+ service.id">{{ getCategoryName(service.categoryId).length > 15 ? getCategoryName(service.categoryId).slice(0,15) + '...' : getCategoryName(service.categoryId) }}</small>
                <b-tooltip :target="'serviceCat-' + service.id">
                    {{getCategoryName(service.categoryId)}}
                </b-tooltip>
              </div>
            </router-link>
          </li>
        </ul>
      </template>
    </div>
    <div class="col-lg-10">
      <router-view v-if="!servicesLoading" :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import RouterCheck from '@/mixins/RouterCheck';
import StatusHelper from '../mixins/StatusHelper';

export default {
  name: 'ProjectServices',
  mixins: [RouterCheck, StatusHelper],
  components: {
    LoadingSpinner,
  },
  created() {
    this.$store.dispatch('Service/fetchServices', parseInt(this.$route.params.project_id, 10))
      .then(() => {
        this.pushDefaultRoute();
      });

    this.dispatchToFetchLookups();
  },
  watch: {
    $route: 'pushDefaultRoute',
  },
  computed: {
    ...mapState('Service', {
      servicesLoading: state => state.loading,
    }),
    ...mapGetters('Service', ['orderedServices', 'getDefaultService']),
    ...mapGetters(LookupModules.SERVICE_STATUSES.namespace, {
      getStatusName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_CATEGORIES.namespace, {
      getCategoryName: 'getName',
    }),
  },
  methods: {
    dispatchToFetchLookups() {
      this.$store.dispatch(`${LookupModules.SERVICE_CATEGORIES.namespace}/fetchOptions`,
        LookupModules.SERVICE_CATEGORIES.url);
      this.$store.dispatch(`${LookupModules.AGREEMENT_TYPES.namespace}/fetchOptions`,
        LookupModules.AGREEMENT_TYPES.url);
      this.$store.dispatch(`${LookupModules.SERVICE_TYPES.namespace}/fetchOptions`,
        LookupModules.SERVICE_TYPES.url);
      this.$store.dispatch(`${LookupModules.SERVICE_STATUSES.namespace}/fetchOptions`,
        LookupModules.SERVICE_STATUSES.url);
      this.$store.dispatch(`${LookupModules.SERVICE_PRODUCTS.namespace}/fetchOptions`,
        LookupModules.SERVICE_PRODUCTS.url);
    },
    pushDefaultRoute() {
      if (this.$route.name === 'projectServices' && this.getDefaultService) {
        this.$router.push({
          name: 'projectService',
          params: {
            project_id: parseInt(this.$route.params.project_id, 10),
            id: this.getDefaultService.id,
          },
        });
      }
    },
  },
};
</script>
